module.exports = __webpack_public_path__ + "static/media/AddItemColor.34140f25.svg";